import axios, { AxiosResponse } from "axios";
import { Axios } from "./Axios";
import { TypeEndereco, TypeEnderecoTipo, TypeEstado, TypeMunicipio } from "../Models/Pessoa/Endereco";

export type InformacoesDoViaCEP = {
    cep?: string,
    logradouro?: string,
    complemento?: string,
    bairro?: string,
    localidade?: string,
    uf?: string,
    ibge?: number,
    ddd?: string
}


export class EnderecoService {
    public listarTiposEndereco(): Promise<AxiosResponse<TypeEnderecoTipo[]>>{
        return Axios.get<TypeEnderecoTipo[]>(`Endereco/listarTiposEnderecos`);
    }

    public listarEstados(): Promise<AxiosResponse<TypeEstado[]>>{
        return Axios.get<TypeEstado[]>(`Endereco/listarEstadosBrasileiros`);
    }

    public listarMunicipios(estado: TypeEstado): Promise<AxiosResponse<TypeMunicipio[]>> {
        return Axios.post<TypeMunicipio[]>(`Endereco/listarMunicipios`, estado);
    }

    public async obterInformacoesDoCEP(cep: string): Promise<InformacoesDoViaCEP>{

        return new Promise((resolve, reject) => {
            axios.get(`https://viacep.com.br/ws/${cep}/json/`)
            .then((resposta) => {
                if (resposta.data["erro"]?.toString() === true.toString()) { 
                    return reject("O CEP não existe") 
                };

                const informacoesDoCEP: InformacoesDoViaCEP = resposta.data as InformacoesDoViaCEP;
                return resolve(informacoesDoCEP)
            }).catch((err) => reject(err));
        })

    }

}